import { render, staticRenderFns } from "./createcountrybill.vue?vue&type=template&id=2adb7d8a&"
import script from "./createcountrybill.vue?vue&type=script&lang=ts&"
export * from "./createcountrybill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createcountrybill.vue"
export default component.exports